import React from "react";

const StartRegistration = () => {
  return <div>StartRegistrations</div>;
};

export default StartRegistration;
